<template>
  <div class="radio-group">
    <div
      v-for="layout in layouts"
      :id="`form-select-layout-${layout.name}`"
      :key="layout.name"
      class="radio-button"
      :class="{ 'selected': selected.name === layout.name }"
      tabindex="0"
      @click="$emit('select', layout)"
    >
      <div class="description">
        <div class="label">
          {{ layout.marketCount }} Markets&nbsp; × &nbsp;{{ layout.tileCount }} Broadcasts
        </div>
        <ul class="requirements">
          <li>
            - For {{ layout.orientation }} displays in {{ layout.resolution }} mode
          </li>
          <li>
            - Showing {{ layout.marketsCount }} markets with {{ layout.tileCount }} broadcasts
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LayoutTypeSelect',
  props: {
    layouts: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Object,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variables";
@import "~@/assets/scss/inputs";

.radio-group {
  padding: 24px 0;
}

.radio-button {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  padding-left: 34px;
  position: relative;
  outline: none;

  &:not(:last-child) {
    margin-bottom: 55px;
  }

  &:before {
    content: '';
    display: block;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.05);
    border: solid 1px $input-border-color;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    transition: $input-transition;
  }
  &:not(:last-child) {
    margin-bottom: 55px;
  }

  &:not(.selected) {
    &:hover {
      &:before {
        border-color: $input-hover-border-color;
      }
    }

    &:focus {
      &:before {
        border-color: $input-focus-border-color;
      }
    }
  }

  &:after {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background-color: $white;
    box-sizing: border-box;
    position: absolute;
    top: 6px;
    left: 6px;
    opacity: 0;
    transition: $input-transition;
  }

  &.selected:after {
    opacity: 1;
  }
}

.description {
  min-height: 24px;
  line-height: 24px;
}

.label {
  font-size: $size-4;
  line-height: 1.18;
  color: $white;
}

.requirements {
  font-size: 12px;
  line-height: 1.67;
  color: $grey;
  list-style: none;
  padding: 0;
  margin: 4px 0;
}
</style>
